import React, { useEffect } from 'react';
import lrLogo from '../IMG/Logos/R8962 Lighting Reality transparent.png'
import { useDispatch, useSelector } from 'react-redux';
import { initialState } from '../store/initial-state';
import selectActions from '../store/actions/selectActions';

const Logo = (props) => {
  const logo = useSelector((state) => state.Select.logo);
  const theme = useSelector((state) => state.Select.theme);
  const dispatch = useDispatch();

  useEffect(() => {
    if (logo === initialState.Select.logo) {
      dispatch(selectActions.UpdateLogo({ logo: lrLogo }));
      dispatch(selectActions.UpdateText({ fileText: "Change Logo" }));
    }
  }, [dispatch, logo]);

  return (
    <img style={{ "height": "32px" }}
      alt="Logo"
      src={theme ? logo : lrLogo}
      {...props}
    />
  );
};

export default Logo;
